import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'vn',
	(_, [hasVn]) => `
		width: 4%;
		float: left;

		@media (max-width: 720px) {
			width: ${hasVn ? `34px` : `10px`};
		}
	`
  ],
  [
    'vnInner',
	`
			min-width: 20px;
			min-height: 1px;
			padding: 0 0 0 6px;
			line-height: 28px;
			font-size: 16px;
			text-align: left;
			position: relative;
			float: left;

			@media (max-width: 720px) {
				min-width: 0px;
			}
	`
  ],
  [
	  'transform',
	  `
		:lang(ar){
			transform: scaleX(-1);
			direction: rtl;
		}
	  `
  ]
]);
